import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { DirtyCheck } from './dirty-check';
import { DirtyCheckModalComponent } from '../components/modals/dirty-check-modal/dirty-check-modal.component';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

export const canDeactivateDirtyCheck: CanDeactivateFn<DirtyCheck> = (
  component: DirtyCheck,
  currentRoute: ActivatedRouteSnapshot,
  currentState: RouterStateSnapshot,
  nextState?: RouterStateSnapshot
) => {
  if (component['checkDirty'] && component.checkDirty()) {
    return new Promise<boolean>((resolve) => {
      const modalService = inject(NgbModal);
      modalService.open(DirtyCheckModalComponent).result.then(
        () => {
          resolve(true);
        },
        () => {
          resolve(false);
        }
      );
    });
  }
  return true;
};
